/**
 * @module geo/components
 *
 */

import {Observable} from 'rxjs/Observable';
import {fromPromise} from 'rxjs/observable/fromPromise';

import {addMenuItemCreatorP} from '../actions/creators/add.menuitem.creator';
import {ADD_MENU_ITEM} from '../payload/facade';
import {ExtensionType} from '../types/extensions';
import {LauncherMenuExtension, LauncherMenuExtensionProperties} from '../types/extensions/launcher.menu';
import {AddMenuItemOptions, MenuItem} from '../types/menu.item';

import {Component} from './component';
import { ComponentProperties } from '../types/component';

/**
 * The function launcher component
 *
 * Example of initialization:
 *
 * ```
 * var components: {
 *          'FunctionsLauncher': {
 *             visible: true,
 *                properties: {
 *                     functionalities: ["cb647651-a745-11e7-bafe-4fc6e655f18d",
 *                                      "ce041d76-bfa3-11e7-b648-cbbc512c71a1"],
 *                     functionalitiesNames: ["Search departement", "régions"],
 *                     groups: ["Analyses"]
 *                }
 *           }
 *      }
 * ```
 *
 * To view how to add menuItem you can see the example :
 * 
 * see [[functionsLauncherMenuItem]]
 *
 * @since v2.0.1
 */
export class FunctionsLauncher extends Component {
  properties: FunctionsLauncherProperties;
  defaultExtensionType = ExtensionType.LAUNCHER;

  constructor(geoappuid: string, options: any) {
    super(geoappuid, options);
    this.properties = options.properties || {};
  }

  public buildExtension(properties: LauncherMenuExtensionProperties):LauncherMenuExtension {
    const type = this.defaultExtensionType;
    let enable, handle;
    if (properties.menuName) {
      enable = (name: string): boolean => {
        return properties.menuName === name;
      }
    } else if (properties.enable) {
      enable = properties.enable;
    }
    if (properties.handle) {
      handle = properties.handle;
    }

    return {type, properties: {handle, enable}} as LauncherMenuExtension;
  }

  /**
   * Add a MenuItem to the FunctionLauncher component
   * @since v2.1.0
   */
  public addMenuItem(menuItem: MenuItem, options?: AddMenuItemOptions):Observable<any> {
    if (!this.store) {
      throw Error('store not defined');
    }
    const extension = new ADD_MENU_ITEM({menuItem, options});
    return fromPromise(addMenuItemCreatorP(extension, this.store.dispatch));
  }
}

/**
 * properties available for [[FunctionsLauncher]]
 */
export interface FunctionsLauncherProperties extends ComponentProperties {
  /**
   * List of functionalities to show at startup(by id )
   */
  functionalities?: string[];
  /**
   * list of functionalities to show at startup(by name)
   */
  functionalitiesNames?: string[];
  /**
   * display only listed functionalities and groups in
   * function launcher . If groups is set all functionalities in group
   * are availables
   */
  groups?: string[];
}

// (1) A l'activation execute la fonctionalité attachée (via configEntry)  elle
// existe, sinon execute "handler"